import {ColorDto} from "../Color";
import {FontDto} from "../DiagramsApi";
import {HorizontalAlign, LabelAlignment, VerticalAlign} from "../LabelAlignment";
import {StyleDto} from "./StyleDto";

export interface ColorConfig {
    r?: number;
    g?: number;
    b?: number;
    a?: number;
}

export interface FontConfig {
    color?: ColorConfig;
    name?: string | null;
    size?: number | null;
    styles?: Array<string> | null;
}

export interface LabelAlignmentConfig {
    horizontal?: HorizontalAlign | null;
    vertical?: VerticalAlign | null;
}

export interface StyleDtoConfig {
    lineColor?: ColorConfig;
    fillColor?: ColorConfig;
    font?: FontConfig;
    lineWidth?: number | null;
    labelAlignment?: LabelAlignmentConfig;
}

export class StyleDtoFactory {

    createStyleDto(config: StyleDtoConfig): StyleDto | undefined {
        let lineColor: ColorDto | null = null;
        let fillColor: ColorDto | null = null;
        let fontColor: ColorDto | null = null;
        let font: FontDto | null = null;
        let lineWidth = config.lineWidth ?? null;
        let labelAlignment: LabelAlignment | null = null;

        if (config.lineColor?.r && config.lineColor?.g && config.lineColor?.b) {
            lineColor = {
                r: config.lineColor.r,
                g: config.lineColor.g,
                b: config.lineColor.b,
                a: config.lineColor.a
            };
        }

        if (config.fillColor?.r && config.fillColor?.g && config.fillColor?.b) {
            fillColor = {
                r: config.fillColor.r,
                g: config.fillColor.g,
                b: config.fillColor.b,
                a: config.fillColor.a
            };
        }

        const fontColorConfig = config.font?.color;
        if (fontColorConfig?.r && fontColorConfig?.g && fontColorConfig?.b) {
            fontColor = {
                r: fontColorConfig.r,
                g: fontColorConfig.g,
                b: fontColorConfig.b,
                a: fontColorConfig.a
            };
        }

        if (fontColor || config.font?.name || config.font?.size || config.font?.styles) {
            font = {
                color: fontColor,
                name: config.font?.name ?? null,
                size: config.font?.size ?? null,
                styles: config.font?.styles ?? null
            };
        }

        if (config.labelAlignment?.horizontal && config.labelAlignment?.vertical) {
            labelAlignment = {
                horizontal: config.labelAlignment.horizontal,
                vertical: config.labelAlignment.vertical
            };
        }

        if (lineColor || fillColor || font || lineWidth || labelAlignment) {
            return {
                lineColor: lineColor,
                fillColor: fillColor,
                font: font,
                lineWidth: lineWidth,
                labelAlignment: labelAlignment
            };
        }

        return undefined;
    }
}
